import React from 'react';
import FormRow, { FormRowProps } from './FormRow';

const BigFormRow = ({ children, ...props }: FormRowProps) => {
  return (
    <FormRow colMd={12} colXl={12} {...props}>
      {children}
    </FormRow>
  );
};

export default BigFormRow;
